import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// todo: define this
interface Transaction {
  id: string;
  [key: string]: any;
}

const bulkTransactionSlice = createSlice({
  name: 'bulkTransaction',
  initialState: [] as Transaction[],
  reducers: {
    updateBulkTransaction: (state, action: PayloadAction<Transaction>) => {
      if (!state) return state;

      const index = state.findIndex(
        (transaction) => transaction.id === action.payload.id
      );
      if (index !== -1) {
        state[index] = action.payload;
      } else {
        state.push(action.payload);
      }
    },
    createBulkTransaction: (state, action: PayloadAction<Transaction>) => {
      if (!state) return state;
      state.push(action.payload);
    },
    clearBulkTransaction: (state, action: PayloadAction<string>) => {
      if (!state) return state;
      return state.filter((transaction) => transaction.id !== action.payload);
    },
  },
});

export const {
  updateBulkTransaction,
  createBulkTransaction,
  clearBulkTransaction,
} = bulkTransactionSlice.actions;

export default bulkTransactionSlice.reducer;
